export default __webpack_public_path__ + "assets/Orbital_Mechanics.546a05c8.png";